module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content article",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('h1', [_vm._v("Media Coverage")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.king5.com/news/local/seattle/new-map-shows-costs-of-collisions-in-seattle/457175867"
    }
  }, [_c('img', {
    staticClass: "size-medium wp-image-47 alignright",
    attrs: {
      "src": "https://seattlecollisions.timganter.io/blog/wp-content/uploads/2017/07/king5-300x169.jpg",
      "alt": "",
      "srcset": "https://seattlecollisions.timganter.io/blog/wp-content/uploads/2017/07/king5-300x169.jpg 300w, https://seattlecollisions.timganter.io/blog/wp-content/uploads/2017/07/king5-768x432.jpg 768w, https://seattlecollisions.timganter.io/blog/wp-content/uploads/2017/07/king5.jpg 943w",
      "sizes": "(max-width: 300px) 100vw, 300px"
    }
  })]), _c('strong', [_vm._v("Seattle King 5 (local NBC)")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.king5.com/news/local/seattle/new-map-shows-costs-of-collisions-in-seattle/457175867"
    }
  }, [_vm._v("New Seattle map shows costs of collisions (video)")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Visualising Data / Andy Kirk Blog")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.visualisingdata.com/2017/07/best-visualisation-web-may-2017/"
    }
  }, [_vm._v("Best of The Visualisation Web, May 2017")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Next City")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://nextcity.org/daily/entry/seattle-app-traffic-deaths-cost-pedestrian-safety"
    }
  }, [_vm._v("Seattle App Puts a Dollar Amount on Traffic Death")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("MyBallard")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.myballard.com/2017/07/05/data-visualization-tool-offers-detailed-collision-info-by-neighborhood/"
    }
  }, [_vm._v("Data visualization tool offers detailed collision info by neighborhood")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Seattle Neighborhood Greenways")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://seattlegreenways.org/blog/2017/05/25/the-cost-of-vision-zero/"
    }
  }, [_vm._v("The Cost of Vision Zero")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("The Urbanist")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.theurbanist.org/2017/06/01/cost-vision-zero/"
    }
  }, [_vm._v("The Cost of Vision Zero")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("The Stranger")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.thestranger.com/slog/2017/06/26/25246990/new-seattle-visionzero-app-shows-car-related-collisions-and-costs-in-local-hoods-since-2006"
    }
  }, [_vm._v("New Seattle #VisionZero App Shows Car-Related Collisions and Costs In Local ‘Hoods Since 2006")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Capitol Hill Eco District")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://capitolhillecodistrict.org/vision-zero-2030-case-live-long/"
    }
  }, [_vm._v("Vision Zero by 2030 (in case I live that long)")])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Capitol Hill Seattle Blog")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.capitolhillseattle.com/2017/07/capitol-hill-community-post-vision-zero-by-2030-in-case-i-live-that-long/"
    }
  }, [_vm._v("Capitol Hill Community Post | Vision Zero By 2030 (in case I live that long)")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31c1ce32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about/MediaCoverage.vue
// module id = 426
// module chunks = 1